import "./index.less";
import CloseIcon from "@/assets/common/ic_close.svg";

interface ExpireProps {
  visible: boolean;
  onClose: () => void;
}

export default function MobileExpire(props: ExpireProps) {
  const { visible, onClose } = props;
  return (
    <>
      {visible && (
        <div className="mobile-expire">
          文件链接7天内有效，保存至AI会记
          <img onClick={() => onClose()} className="close-icon" src={CloseIcon} />
        </div>
      )}
    </>
  );
}
